import { render, staticRenderFns } from "./swiper-item.vue?vue&type=template&id=58a02493&"
import script from "./swiper-item.vue?vue&type=script&lang=js&"
export * from "./swiper-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports